/* Loading screen: a perfume bottle fills with amber juice as the page really loads, gives a little spritz,
   then the screen lifts away. Shown once per visit by default (see the Loading screen theme settings). */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!root.classList.contains('jl-on')) return;
  var el = document.querySelector('[data-loader]');
  if (!el) { root.classList.remove('jl-on'); return; }

  var nameEl = el.querySelector('[data-jl-name]');
  if (nameEl) {
    var txt = nameEl.textContent; nameEl.setAttribute('aria-label', txt); nameEl.textContent = '';
    for (var i = 0; i < txt.length; i++) {
      var s = document.createElement('span');
      s.textContent = txt.charAt(i) === ' ' ? '\u00a0' : txt.charAt(i);
      s.style.animationDelay = (0.15 + i * 0.035).toFixed(3) + 's';
      nameEl.appendChild(s);
    }
  }
  var dust = el.querySelector('[data-jl-dust]');
  if (dust) {
    for (var d = 0; d < 22; d++) {
      var m = document.createElement('i'), sz = 2 + Math.random() * 4;
      m.style.cssText = 'left:' + (Math.random() * 100).toFixed(1) + '%;width:' + sz.toFixed(1) + 'px;height:' + sz.toFixed(1) +
        'px;animation-duration:' + (5 + Math.random() * 6).toFixed(1) + 's;animation-delay:-' + (Math.random() * 9).toFixed(1) + 's';
      dust.appendChild(m);
    }
  }

  var pct = el.querySelector('[data-jl-pct]');
  var MIN = 1500, MAX = 6000;
  var start = performance.now(), loaded = document.readyState === 'complete', p = 0, finished = false;
  if (!loaded) window.addEventListener('load', function () { loaded = true; });

  function finish() {
    if (finished) return; finished = true;
    el.classList.add('is-done'); root.classList.add('jl-done');
    setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
      root.classList.remove('jl-on');
    }, 1300);
  }
  function frame(now) {
    var t = now - start;
    var timeP = Math.min(1, t / MIN); timeP = 1 - Math.pow(1 - timeP, 2.2);
    var cap = (loaded || t > MAX) ? 1 : 0.9;
    p += (Math.min(timeP, cap) - p) * 0.1;
    if (p > 0.995) p = 1;
    el.style.setProperty('--p', p.toFixed(4));
    if (pct) { var n = Math.round(p * 100); pct.textContent = n < 10 ? '0' + n : String(n); }
    if (p >= 1) { el.classList.add('is-full'); setTimeout(finish, 520); return; }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
  window.addEventListener('pageshow', function (e) { if (e.persisted) finish(); });
})();
